// extracted by mini-css-extract-plugin
export var brandCard = "BrandCard-module--brandCard--1c242";
export var contentContainer = "BrandCard-module--contentContainer--b5fc0";
export var contentContainerInner = "BrandCard-module--contentContainerInner--521d3";
export var contentContainerText = "BrandCard-module--contentContainerText--975e0";
export var heading = "BrandCard-module--heading--4c45b";
export var imageContainer = "BrandCard-module--imageContainer--ed7e6";
export var imageCover = "BrandCard-module--imageCover--d14ba";
export var imageLogo = "BrandCard-module--imageLogo--6c677";
export var link = "BrandCard-module--link--6aeb8";